export default {
    da: {
        sourceSelectionButtonLaptopPCWirelessText: "Bærbar PC trådløst",
        sourceSelectionButtonMeetingRoomPCText: "Møderum PC",
        sourceSelectionButtonMeetingRoomPCWithWebCamText: "Møderum PC med webcam",
        sourceSelectionButtonLaptopPCCableText: "Bærbar PC kablet",
        sourceSelectionButtonWhiteboardPCText: "Whiteboard PC",
        sourceSelectionButtonOtherAVDeviceText: "Anden AV enhed",
        subjectText: "Booket på skærmen",
        appointmentAllDayText: "Hele dagen",
        bookButtonText: "BOOK",
        extendButtonText: "FORLÆNG",
        cancelButtonText: "AFSLUT",
        confirmButtonText: "START",
        maskText: "Optaget",
        generalMeetingRoomText: "Møderum: ",
        generalOngoingMeeting: "Igangværende møde ",
        generalNextMeetingText: "Næste møde ",
        generalNoMoreBookingsToday: "Ikke flere bookinger i dag",
        generalDialMeetingStartsInText: "MØDE STARTER OM",
        generalDialMeetingEndsInText: "MØDE SLUTTER OM",
        generalDialMeetingReleaseRoomInText: "FRIGØRER RUM OM",
        generalBookMeetingToSelectSourceText: "Book møde for at vælge kilde",
        generalStartMeetingToSelectSourceText: "Start møde for at vælge kilde",
        generalSelectSourceForPresentationText: "Vælg kilde til præsentationen",
        dialogMeetingRoomText: "Møderum: ",
        dialogBookToText: "Book til: ",
        dialogExtendToText: "Forlæng til: ",
        noAvailableBookingTimes: "Der kan ikke bookes et møde i øjeblikket da et andet er ved at starte.",
        noAvailableExtensionTimes: "Mødet kan ikke forlænges da et andet er ved at starte.",
        turnOn: "TÆND",
        turnOff: "SLUK"
    },
    en: {
        sourceSelectionButtonLaptopPCWirelessText: "Laptop PC Wireless",
        sourceSelectionButtonMeetingRoomPCText: "Meeting room PC",
        sourceSelectionButtonMeetingRoomPCWithWebCamText: "Meeting room PC with webcam",
        sourceSelectionButtonLaptopPCCableText: "Laptop PC cable",
        sourceSelectionButtonWhiteboardPCText: "Whiteboard PC",
        sourceSelectionButtonOtherAVDeviceText: "Other AV Device",
        subjectText: "Booked on-screen",
        appointmentAllDayText: "All day",
        bookButtonText: "BOOK",
        extendButtonText: "EXTEND",
        cancelButtonText: "END",
        confirmButtonText: "START",
        maskText: "Occupied",
        generalMeetingRoomText: "Meeting room: ",
        generalOngoingMeeting: "Ongoing meeting ",
        generalNextMeetingText: "Next meeting ",
        generalNoMoreBookingsToday: "No more bookings today",
        generalDialMeetingStartsInText: "MEETING STARTS IN",
        generalDialMeetingEndsInText: "MEETING ENDS IN",
        generalDialMeetingReleaseRoomInText: "RELEASING ROOM IN",
        generalBookMeetingToSelectSourceText: "Book meeting to select source",
        generalStartMeetingToSelectSourceText: "Start meeting to select source",
        generalSelectSourceForPresentationText: "Select source for presentation",
        dialogMeetingRoomText: "MeetingRoom: ",
        dialogBookToText: "Book to: ",
        dialogExtendToText: "Extend to: ",
        noAvailableBookingTimes: "You cannot currently book a meeting because another is about to start.",
        noAvailableExtensionTimes: "The meeting cannot be extended because another is about to start.",
        turnOn: "ON",
        turnOff: "OFF"
    },
    sv: {
        sourceSelectionButtonLaptopPCWirelessText: "Laptop med trådlös anslutning",
        sourceSelectionButtonMeetingRoomPCText: "Mötesrums-PC",
        sourceSelectionButtonMeetingRoomPCWithWebCamText: "Mötesrums-PC med kamera",
        sourceSelectionButtonLaptopPCCableText: "Laptop med trådad anslutning",
        sourceSelectionButtonWhiteboardPCText: "Whiteboard-PC",
        sourceSelectionButtonOtherAVDeviceText: "Övriga AV-enheter",
        subjectText: "Bokat på skärm",
        appointmentAllDayText: "Hela dagen",
        bookButtonText: "BOKA",
        extendButtonText: "FÖRLÄNG",
        cancelButtonText: "AVSLUTA",
        confirmButtonText: "STARTA",
        maskText: "Upptaget",
        generalMeetingRoomText: "Mötesrum: ",
        generalOngoingMeeting: "Pågående möte ",
        generalNextMeetingText: "Nästa möte ",
        generalNoMoreBookingsToday: "Inga fler möten idag",
        generalDialMeetingStartsInText: "MÖTET BÖRJAR OM",
        generalDialMeetingEndsInText: "MÖTET SLUTAR OM",
        generalDialMeetingReleaseRoomInText: "FRIGÖR RUMMET OM",
        generalBookMeetingToSelectSourceText: "Boka ett möte för att välja presentationskälla",
        generalStartMeetingToSelectSourceText: "Påbörja ett möte för att välja presentationskälla",
        generalSelectSourceForPresentationText: "Välj en källa för din presentation",
        dialogMeetingRoomText: "Mötesrum: ",
        dialogBookToText: "Boka till: ",
        dialogExtendToText: "Förläng till: ",
        noAvailableBookingTimes: "Du kan inte boka ett möte då ett nytt möte snart påbörjas.",
        noAvailableExtensionTimes: "Mötet kan inte förlängas då ett nytt möte snart ska påbörjas.",
        turnOn: "PÅ",
        turnOff: "AV"
    }
} as any;
